import lrCountUp from './_src/lrCountUp.vue'

lrCountUp.install = function(Vue) {
  Vue.component(lrCountUp.name, lrCountUp)
}

export default lrCountUp